import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import heroLandingImage from './assets/transparent-bwob.png';

const preloadLandingHero = document.createElement('link');
preloadLandingHero.rel = 'preload';
preloadLandingHero.as = 'image';
preloadLandingHero.href = heroLandingImage;
document.head.appendChild(preloadLandingHero);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
